import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import styles from "./ProfileForm.module.css";
import commonStyles from "components/commonStyle/commonStyle.module.css";
import { FaArrowAltCircleRight } from "react-icons/fa";
import { KidsProfileFormProps } from "modules/profile";
import { computeAge } from "utils/profile";
import ErrorFailed from "components/errorFailed/errorFailed";
import { setKidProfile } from "services/profileManegement/set-kid-profile";
import { smoothScrollPolyfill } from "utils/smoothScroll";


export default function KidProfileForm({ initialValues, buttonOptions = [], onSubmitSuccess }: KidsProfileFormProps) {
    const [formValues, setFormValues] = useState(initialValues);
    const navigate = useNavigate();
    const [error, setError] = useState<string | null>(null);
    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
        const { name, value } = e.target;
        if (name === 'zip') {
            const numericValue = value.replace(/\D/g, '').slice(0, 5);;
            setFormValues({
                ...formValues,
                [name]: numericValue,
            });
            return; 
        }
        setFormValues({
            ...formValues,
            [name]: name === 'birth_date' && value ? new Date(value) : value,
            age: name === 'birth_date' && value ? computeAge(new Date(value)) : formValues.age
        });
    };
    useEffect(() => {
        setFormValues(initialValues);
        smoothScrollPolyfill(0, 1000);


    }, [initialValues]);

    const handleSubmit = async (e?: React.FormEvent<HTMLFormElement>, redirectTo?: string): Promise<boolean> => {
        if (e) e.preventDefault();
    
        const formElement = document.querySelector("form");
        if (formElement) {
            const firstInvalidElement = formElement.querySelector("input:invalid, select:invalid, textarea:invalid");
            if (firstInvalidElement) {
                
                const elementPosition = (firstInvalidElement as HTMLElement).getBoundingClientRect().top + window.scrollY;
    
                smoothScrollPolyfill(elementPosition -200, 1000);
                (firstInvalidElement as HTMLElement).focus();
                setError("Bitte füllen Sie alle erforderlichen Felder aus.");
                return false;
            }
        }
    
        const profileData = { ...formValues };
        try {
            const response = await setKidProfile(profileData);
            if (response.success) {
                setError(null);
                setFormValues(initialValues);
                if (redirectTo) {
                    navigate(redirectTo);
                } else {
                    navigate('/reservierungsportal/CustomerHomePage');
                }
                return true;
            } else {
                setError(response.message);
                smoothScrollPolyfill(0, 1000);
                return false;
            }
        } catch (error) {
            console.error("Error saving kid profile:", error);
            return false;
        }
    };
    
    
    
    
    const handleNewKid = async () => {
        try {
            const isSuccess = await handleSubmit(undefined, '/reservierungsportal/NewkidsProfile');
            if (isSuccess) {
                window.location.reload();
            } else {
                smoothScrollPolyfill(0, 1000);

            }
        } catch (error) {
            console.error("Es gab einen Fehler beim Hinzufügen eines neuen Kindes:", error);
            setError("Es gab einen Fehler beim Hinzufügen eines neuen Kindes: Ein Serverfehler ist aufgetreten.");
            smoothScrollPolyfill(0, 1000);
        }
    };


    return (
        <form className={styles.form} onSubmit={handleSubmit} noValidate>
            {error && <ErrorFailed error={error} />}
            <section className={styles.section}>
                <div className={styles.sectionTitle}>
                    <h3>Stammdaten</h3>
                    <p>Die folgenden Angaben sind Pflichtfelder.</p>
                </div>
                <div className={commonStyles.formGroupRow}>
                    <div className={commonStyles.formGroup}>
                        <label htmlFor="first_name">Vorname*</label>
                        <input
                            type="text"
                            id="first_name"
                            name="first_name"
                            value={formValues.first_name}
                            onChange={handleInputChange}
                            required
                        />
                    </div>
                    <div className={commonStyles.formGroup}>
                        <label htmlFor="last_name">Nachname*</label>
                        <input
                            type="text"
                            id="last_name"
                            name="last_name"
                            value={formValues.last_name}
                            onChange={handleInputChange}
                            required
                        />
                    </div>
                </div>
                <div className={commonStyles.formGroupRow}>
                    <div className={commonStyles.formGroup}>
                        <label htmlFor="birth_date">Geburtsdatum*</label>
                        <input type="date"
                            id="birth_date"
                            name="birth_date"
                            value={formValues.birth_date instanceof Date
                                ? formValues.birth_date.toISOString().split('T')[0]
                                : ""}
                            onChange={handleInputChange} />
                    </div>
                    <div className={commonStyles.formGroupOld}>
                        <p>{formValues.age} Jahre</p>
                    </div>
                </div>
                <div className={commonStyles.formGroup}>
                    <label htmlFor="country">Land*</label>
                    <select
                        id="country"
                        name="country"
                        value={formValues.country}
                        onChange={handleInputChange}
                        required
                    >
                        <option value="Deutschland">Deutschland</option>
                    </select>
                </div>
                <div className={commonStyles.formGroupRow}>
                    <div className={commonStyles.formGroup}>
                        <label htmlFor="zip">PLZ*</label>
                        <input
                            type="text"
                            id="zip"
                            name="zip"
                            value={formValues.zip}
                            onChange={handleInputChange}
                            required
                        />
                    </div>
                    <div className={commonStyles.formGroup}>
                        <label htmlFor="city">Stadt*</label>
                        <input
                            type="text"
                            id="city"
                            name="city"
                            value={formValues.city}
                            onChange={handleInputChange}
                            required
                        />
                    </div>
                </div>
                <div className={commonStyles.formGroup}>
                    <label htmlFor="street">Straße & Haus Nr.*</label>
                    <input
                        type="text"
                        id="street"
                        name="street"
                        value={formValues.street}
                        onChange={handleInputChange}
                        required
                    />
                </div>
            </section>

            <section className={styles.section}>
                <div className={styles.sectionTitle}>
                    <h3>Allergien und Krankheiten</h3>
                    <p>Bitte geben Sie Allergien und Krankheiten von Kind ein.</p>
                </div>
                <div className={commonStyles.formGroup}>
                    <label htmlFor="allergy_medication">Allergien & Medikamente</label>

                    <textarea
                        id="allergy_medication"
                        name="allergy_medication"
                        value={formValues.allergy_medication}
                        onChange={handleInputChange}
                        rows={3}
                    />
                </div>
            </section>
            <section className={styles.section}>
                <div className={styles.sectionTitle}>
                    <h3>Ergänzungen</h3>
                    <p>Bitte geben Sie Ihre weitere notiz ein.</p>
                </div>
                <div className={commonStyles.formGroup}>
                    <label htmlFor="note">Notiz</label>
                    <textarea
                        id="note"
                        name="note"
                        value={formValues.note}
                        onChange={handleInputChange}
                        rows={3}
                    />
                </div>
            </section>
            <section className={styles.section}>
                <div className={styles.addButtonContainer}>
                    <button
                        type="button"
                        onClick={handleNewKid}
                        className={`${commonStyles.commonButton} ${styles.addButton}`}>
                        <span>Kinderprofil hinzufügen</span>
                        <FaArrowAltCircleRight className={`${commonStyles.commonButtonIcon} ${styles.buttonIcon}`} />
                    </button>
                </div>
            </section>
            <div className={styles.buttonContainer}>
                {buttonOptions.map((button, index) => (
                    <button
                        key={index}
                        type="submit"
                        className={`${commonStyles.commonButton} ${button.onClick ? commonStyles.backButton : commonStyles.submitButton}`}
                        onClick={button.onClick}
                    >
                        {button.label}
                        {button.icon && (
                            <span className={`${commonStyles.commonButtonIcon} ${styles.buttonIcon}`}>
                                {button.icon}
                            </span>
                        )}
                    </button>
                ))}
            </div>
        </form>
    );
}
